module.exports = __webpack_public_path__ + "static/media/t16.8a099eb0.jpg";